<template>
  <div>
      <v-toolbar>
        <v-flex xs2>
          <v-select
            :items="graphs"
            label="Report"
            v-model="currentGraph">
          </v-select>
        </v-flex>
        <v-spacer></v-spacer>
        <v-toolbar-title><h2>Facility Weights</h2></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-flex xs2>
          <v-select
            :items="allVintages"
            label="Vintage"
            v-model="selectedVintage">
          </v-select>
        </v-flex>
      </v-toolbar>
      <Loading :msg="loadingMessage" v-if="loading"></Loading>
      <GChart v-if="!loading && currentGraph == 'Tons by Client'"
        type="BarChart"
        :data="series"
        :options="chartOptions"
        :events="chartEvents"
      ></GChart>
      <GChart v-if="!loading && currentGraph == 'Tons by Varietal'"
        type="PieChart"
        :data="seriesVarieties"
        :options="chartOptionsVarieties"
      ></GChart>
    </div>
</template>

<script>
import axios from 'axios'
import myMixins from '../mixins/myMixins'
import Loading from './Loading'
import { GChart } from 'vue-google-charts'
export default {
  components: {
    GChart,
    Loading
  },
  data () {
    return {
      loading: false,
      loadingMessage: 'Loading...',
      //      currentGraph: 'Tons by Client',
      currentGraph: 'Tons by Varietal',
      graphs: ['Tons by Client', 'Tons by Varietal'],
      data: {},
      allVintages: [],
      selectedVintage: 0,
      chartEvents: {
        'click': (evt) => {
          let items = evt.targetID.split('#')
          let indexInSeries = parseInt(items[2])
          let code = this.series[indexInSeries+1][0]
          this.$store.state.client = this.clientData[code]
          this.$store.state.vintage = this.selectedVintage
          this.$router.push({
            path: '/weightags'
          })
        }
      },
      chartOptions: {
        height: 800,
        chartArea: {
          'width': '80%',
          'height': '90%'
        },
        title: 'Tonnage by Client',
        titleTextStyle: {
          color: 'white'
        },
        series: {
          1: {
            annotations: {
              textStyle: { fontSize: 10, color: 'white' }
            }
          }
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        display: false,
        legend: {
          textStyle: {
            color: 'white'
          }
        },
        backgroundColor: 'black',
        dataLabels: {
          enabled: true
        },
        vAxis: {
          textStyle: {
            color: 'white',
            fontSize: 10
          }
        },
        hAxis: {
          textStyle: {
            color: 'white'
          }
        },
        tooltip: {

        }
      },
      chartOptionsVarieties: {
        height: 800,
        // width: 1600,
        is3D: true,
        // chartArea: {
        //   'width': '80%',
        //   'height': '90%'
        // },
        title: 'Tonnage by Varietal',
        titleTextStyle: {
          color: 'white'
        },
        series: {
          1: {
            annotations: {
              textStyle: { fontSize: 10, color: 'white' }
            }
          }
        },
        legend: {
          alignment: 'center',
          position: 'right',
          textStyle: {
            color: 'white',
            fontSize: '12'
          }
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        display: false,
        backgroundColor: 'black',
        dataLabels: {
          enabled: true
        },
        vAxis: {
          textStyle: {
            color: 'white',
            fontSize: 10
          }
        },
        hAxis: {
          textStyle: {
            color: 'white'
          }
        },
        tooltip: {

        }
      },
      series: [],
      seriesVarieties: [],
      dataVarieties: [],
      vintageTotal: 0,
      clientData: {}
    }
  },
  mixins: [myMixins],
  // beforeRouteEnter (to, from, next) {
  //   next(vm => {
  //     this.
  //   })
  // },
  created () {
    this.selectedVintage = this.$store.state.vintage
    this.retrieveAllVintages()
  },
  computed: {
    icon () {
      return this.getIcon('WT')
    },
    vintage () {
      return this.$store.state.vintage
    },
    clientcode () {
      return this.$store.state.client.CODE
    },
    client () {
      return this.$store.state.client
    }
  },
  watch: {
    selectedVintage: function (ov, nv) {
      this.retrieveWeightags()
    }
  },
  methods: {
    retrieveAllVintages () {
      axios
        .get(process.env.VUE_APP_BACKEND+'lots/uniqueVintageYears')
        .then(response => {
          this.allVintages = response.data.data
          //          this.selectedVintage = this.allVintages[0]
          this.retrieveWeightags()
        })
    },
    totalWeight () {
      var total = 0
      this.tableData.forEach(function (item) {
        total += item.totalWeight
      })
      return this.roundTons(total / 2000)
    },
    retrieveWeightags () {
      this.loading = true
      axios
        .get(process.env.VUE_APP_BACKEND+'weightags?vintage=' + this.selectedVintage)
        .then((response) => {
          this.tableData = response.data.data
          let $this = this
          this.data = {}
          this.dataVarieties = {}
          this.clientData = {}
          response.data.data.forEach(weight => {
            if ($this.data[weight.clientcode]) {
              $this.data[weight.clientcode].total += weight.totalWeight
            } else {
              $this.data[weight.clientcode] = {}
              $this.data[weight.clientcode].total = weight.totalWeight
              $this.data[weight.clientcode].client = weight.Client
            }
            if ($this.dataVarieties[weight.variety]) {
              $this.dataVarieties[weight.variety].total += weight.totalWeight
            } else {
              $this.dataVarieties[weight.variety] = {}
              $this.dataVarieties[weight.variety].total = weight.totalWeight
            }
          })
          this.series = []
          this.seriesVarieties = []
          this.vintageTotal = 0
          Object.keys(this.data).forEach(function (key) {
            let item = [$this.data[key].client.CODE, $this.data[key].total/2000]
            $this.vintageTotal += item[1]
            $this.series.push(item)
            $this.clientData[$this.data[key].client.CODE] = $this.data[key].client
          })
          Object.keys(this.dataVarieties).forEach(function (key) {
            let item = [key, $this.dataVarieties[key].total/2000]
            $this.seriesVarieties.push(item)
          })
          this.series.sort(function (a, b) {
            return b[1] - a[1]
          })
          this.seriesVarieties.sort(function (a, b) {
            return b[1] - a[1]
          })
          this.series = [['ClientCode', 'Total - '+ this.roundTons(this.vintageTotal)]].concat(this.series)
          this.seriesVarieties = [['Variety', 'Total - '+ this.roundTons(this.vintageTotal)]].concat(this.seriesVarieties)
          this.loading = false
        })
    }
  }
}
</script>
<style>
</style>
